
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import GsTreeNode from "../gsTreeNode";
Vue.use(GsTreeNode);

@Component({
  components: {},
})
export default class GsTree extends Vue {
  @Prop() data: any;

  // @Watch("data", {deep: true})
  updateData() {
    this.data.forEach((item) => {
      this.addParent(item, []);
    });
  }

  addParent(child, parentGroup: string[]) {
    if (!parentGroup) {
      child.parentGroup = [];
    } else {
      child.parentGroup = parentGroup;
    }
    if (child.items) {
      child.items.forEach((item) => {
        this.addParent(item, [...child.parentGroup.concat([child.name])]);
      });
    }
  }

  mounted() {
    if (this.data) {
      this.data.forEach((item) => {
        this.addParent(item, []);
      });
      console.log("this.data---------", this.data);
    }
  }
}
